import React from 'react';

import { CmFlex, CmSelect, CmText } from '@/components/uiParts';

interface Props {
  id?: string;
  date: Date;
  width?: string;
  isDisabled?: boolean;
  handleChangeHour: (hour: string) => void;
  handleChangeMinutes: (minutes: string) => void;
}

const MAX_HOUR = 23 as const;
const MAX_MINUTES = 59 as const;

export const CmSelectDigitsTime: React.FC<Props> = ({
  id,
  date,
  width = '44',
  isDisabled = false,
  handleChangeHour,
  handleChangeMinutes,
}: Props) => {
  const consecutiveTimeNums = (timeNum: typeof MAX_HOUR | typeof MAX_MINUTES) =>
    [...Array(timeNum + 1)].map((_, i) => i);

  const toDoubleDigits = (timeNum: number) => {
    const stringTimeNum = timeNum.toString();
    let DigitsNum = '';
    const oneDigit = 1;
    if (stringTimeNum.length !== oneDigit) return stringTimeNum;
    DigitsNum = '0' + stringTimeNum;
    return DigitsNum;
  };

  return (
    <CmFlex align="center" width={width}>
      <CmSelect
        {...{ isDisabled, id }}
        fontSize="large"
        value={date && date.getHours()}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
          handleChangeHour(e.target.value);
        }}
      >
        {consecutiveTimeNums(MAX_HOUR).map((hour) => (
          <option key={hour} value={hour}>
            {toDoubleDigits(hour)}
          </option>
        ))}
      </CmSelect>
      <CmText p="2" fontSize="xl">
        :
      </CmText>
      <CmSelect
        {...{ isDisabled }}
        fontSize="large"
        value={date && date.getMinutes()}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          handleChangeMinutes(e.target.value)
        }
      >
        {consecutiveTimeNums(MAX_MINUTES).map((minutes) => (
          <option key={minutes} value={minutes}>
            {toDoubleDigits(minutes)}
          </option>
        ))}
      </CmSelect>
    </CmFlex>
  );
};
